import React from 'react';

// Material UI
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import {
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
} from '@mui/x-data-grid';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

// Custom Toolbar with Select All button
export default function SelectAllToolbar({ onSelectAll, selectAllState, columnName = 'Has Access', itemType = 'items' }) {
	const selectAllText = `Select "${columnName}" for all ${itemType} visible on this page`;
	const deselectAllText = `Deselect "${columnName}" for all ${itemType} visible on this page`;

	return (
		<GridToolbarContainer>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<Tooltip title={selectAllState ? selectAllText : deselectAllText}>
				<Button
					variant="contained"
					size="small"
					onClick={onSelectAll}
					startIcon={selectAllState ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
					sx={{
						marginLeft: 1,
						backgroundColor: 'white',
						color: 'primary.main',
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: '#FCF7F7',
							boxShadow: 'none',
						},
					}}
				>
					{selectAllState ? 'Select All' : 'Deselect All'}
				</Button>
			</Tooltip>
		</GridToolbarContainer>
	);
}